"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Sarah W",
  quote: "The bi-fold doors have completely transformed our Victorian terrace. The light and space BVP Group created is simply incredible.",
  position: "Leyton",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613388/img/testimonial_sarah_williams.png"
}, {
  author: "James L",
  quote: "Our kitchen renovation exceeded all expectations. Professional, efficient, and the attention to detail is truly world-class.",
  position: "Islington",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613388/img/testimonial_james_lawson.png"
}, {
  author: "Emma R.",
  quote: "BVP Group handled our open-plan conversion flawlessly. They understood the heritage of our Edwardian home perfectly.",
  position: "Stoke Newington",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613388/img/testimonial_emma_richardson.png"
}];
export default function WhatOurClientsSay() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="27801" id="client-success-stories" ref={ref} className={cn("bg-background w-full py-16 md:py-32 lg:py-48 transition-opacity duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-16 text-center">
          <h2 className="text-secondary font-serif text-3xl md:text-6xl lg:text-7xl font-semibold tracking-tight">
            Client Success Stories
          </h2>
          <div className="bg-primary mx-auto mt-6 h-1 w-24 rounded-full opacity-30" />
        </div>

        <div className="mx-auto max-w-5xl">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((item, i) => <CarouselItem key={i} className="basis-full md:basis-11/12 lg:basis-5/6 px-2 md:px-8">
                  <div data-index={i} className="flex flex-col items-center text-center px-4 py-8">
                    <Quote className="text-primary/30 mb-8 size-12 md:size-16" />
                    
                    <blockquote className="mb-10 max-w-3xl">
                      <p className="text-secondary font-serif text-2xl md:text-3xl lg:text-4xl italic leading-relaxed">
                        &ldquo;{item.quote}&rdquo;
                      </p>
                    </blockquote>

                    <div className="flex flex-col items-center gap-4">
                      <SafeHydrate><Avatar className="size-14 border-2 border-primary/20">
                        <AvatarImage src={item.avatar} alt={item.author} className="object-cover" />
                        <AvatarFallback className="bg-muted text-secondary text-lg">
                          {item.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      
                      <div className="text-center">
                        <div className="text-secondary font-sans text-sm font-bold uppercase tracking-widest">
                          {item.author}
                        </div>
                        {item.position && <div className="text-secondary/70 mt-1 text-xs font-semibold tracking-wide uppercase">
                            {item.position}
                          </div>}
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:flex items-center justify-between">
              <CarouselPrevious className="border-primary/20 text-secondary hover:bg-primary hover:text-primary-foreground -left-12 lg:-left-16 size-12 lg:size-14" />
              <CarouselNext className="border-primary/20 text-secondary hover:bg-primary hover:text-primary-foreground -right-12 lg:-right-16 size-12 lg:size-14" />
            </div>
            
            <div className="mt-12 flex justify-center gap-6 md:hidden">
               <CarouselPrevious className="static translate-y-0 translate-x-0 border-primary/20 text-secondary size-14" />
               <CarouselNext className="static translate-y-0 translate-x-0 border-primary/20 text-secondary size-14" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}